// Quick links of a contact (task 1.9, D-038). Phones are saved in E.164 by
// tenax_normalize_phone, handles without @ and lowercase (D-022): a value
// that does not look right gets no link instead of a broken one.

// wa.me wants the number with the country code, digits only
export const whatsappUrl = (phone?: string | null) => {
  const digits = (phone ?? "").replace(/[\s().-]/g, "").replace(/^\+/, "");
  return /^[1-9]\d{7,14}$/.test(digits) ? `https://wa.me/${digits}` : null;
};

export const instagramUrl = (handle?: string | null) => {
  const clean = (handle ?? "").trim().replace(/^@/, "").toLowerCase();
  return /^[a-z0-9._]{1,30}$/.test(clean)
    ? `https://instagram.com/${clean}`
    : null;
};

export const CHANNELS = [
  "whatsapp",
  "instagram_dm",
  "phone",
  "email",
  "meeting",
] as const;
export const OUTCOMES = [
  "sent",
  "replied",
  "no_reply",
  "positive",
  "negative",
] as const;
export type Channel = (typeof CHANNELS)[number] | "other";
export type Outcome = (typeof OUTCOMES)[number];
